import { render } from "./SidePanel.vue?vue&type=template&id=4094f674&scoped=true&ts=true"
import script from "./SidePanel.vue?vue&type=script&lang=ts"
export * from "./SidePanel.vue?vue&type=script&lang=ts"

import "./SidePanel.vue?vue&type=style&index=0&id=4094f674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4094f674"]])

export default __exports__